import { registerApi as api } from '../../api';

export const fetchQueryData = async (Data) => {
    try {
      const token = sessionStorage.getItem('token');
      const response = await api.post('/query-report-reportcolumns', Data, {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
      return {
        data: response.data,
        status: response.status,
      }

    } catch (error) {
      throw error.response ? error.response.data.message : error.message;

    }
  }

export const createReportAndReportColumn = async (reportData) =>{
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/create-report-reportcolumns' , reportData, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return {
      data : response.data,
      status : response.status,
    }
  } catch (error) {
    throw error.response ? error.respose.data.message : error.message;
  }
}


export const fetchReportAndReportColumn = async () => {
  try {
    const response = await api.get('/get-all-report-reportcolumns');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}



export const updateReportAndReportColumn = async (reportcode, reportData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/update-report-reportcolumns/${reportcode}`, reportData,{
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    })
    return response.data
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}



export const deleteReportAndReportColumn = async (reportcode) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/delete-report-reportcolumns/${reportcode}`,{
      headers : {
        'Authorization': `Bearer ${token}`,
      }
    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

